(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["event-gift-speaking"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function initializeGiftForm(root) {
      if (root.dataset.initialized === 'true') return;

      const form = root.querySelector('form');
      const fields = root.querySelector('[data-gift-fields]');

      if (!form || !fields) return;

      const expectedCode = (root.dataset.code || '')
        .trim()
        .toUpperCase();

      if (!expectedCode) return;

      root.dataset.initialized = 'true';

      const name = root.querySelector('[data-gift-name]');
      const email = root.querySelector('[data-gift-email]');
      const phone = root.querySelector('[data-gift-phone]');
      const code = root.querySelector('[data-gift-code]');
      const inputs = [name, email, phone, code];

      inputs.forEach((input) => {
        input.addEventListener('input', () => {
          input.setCustomValidity('');
        });
      });

      form.addEventListener('submit', (event) => {
        inputs.forEach((input) => {
          input.value = input.value.trim();
        });

        const digits = phone.value.replace(/\D/g, '');

        const phoneValid =
          /^\+?[\d\s().-]+$/.test(phone.value) &&
          digits.length >= 7 &&
          digits.length <= 15;

        phone.setCustomValidity(
          phoneValid
            ? ''
            : (
                root.dataset.phoneError ||
                'Please enter a valid phone number.'
              )
        );

        code.setCustomValidity(
          code.value.toUpperCase() === expectedCode
            ? ''
            : (
                root.dataset.codeError ||
                'Please enter the correct event code.'
              )
        );

        if (!form.reportValidity()) {
          event.preventDefault();
        }
      });

      fields.disabled = false;
    }

    function initializeWithin(scope) {
      scope
        .querySelectorAll('[data-event-gift-request]')
        .forEach(initializeGiftForm);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        initializeWithin(document);
      });
    } else {
      initializeWithin(document);
    }

    document.addEventListener('shopify:section:load', (event) => {
      initializeWithin(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["patriox-market-specials"] && !Shopify.designMode) return;
  try {
    

(function () {

  function getQuantity(input) {
    var value = parseInt(input.value, 10);

    if (!Number.isFinite(value)) {
      value = 1;
    }

    return Math.min(99, Math.max(1, value));
  }

  function updateCard(card) {

    var input = card.querySelector('[data-qty]');
    var total = card.querySelector('[data-total]');
    var buy = card.querySelector('[data-buy-now]');

    var quantity = getQuantity(input);
    var price = Number(card.dataset.price);
    var currency = card.dataset.currency || 'USD';

    var formatted = new Intl.NumberFormat(
      'en-US',
      {
        style: 'currency',
        currency: currency
      }
    ).format((quantity * price) / 100);

    total.textContent = 'TOTAL: ' + formatted;

    if (buy) {
      var variantId = card.dataset.variantId;
      var section = card.closest('[data-patriox-market]');
      var root = section.dataset.rootUrl || '/';

      if (!root.endsWith('/')) {
        root += '/';
      }

      if (/^\d+$/.test(variantId || '')) {
        buy.href = root + 'cart/' + variantId + ':' + quantity;
      }
    }
  }

  document.addEventListener('click', function(event) {

    var control = event.target.closest(
      '[data-decrease], [data-increase], [data-buy-now]'
    );

    if (!control) return;

    var card = control.closest('[data-patriox-card]');

    if (!card) return;

    var input = card.querySelector('[data-qty]');

    if (control.hasAttribute('data-decrease')) {

      input.value = Math.max(1, getQuantity(input) - 1);
      updateCard(card);

    } else if (control.hasAttribute('data-increase')) {

      input.value = Math.min(99, getQuantity(input) + 1);
      updateCard(card);

    } else if (control.hasAttribute('data-buy-now')) {

      input.value = getQuantity(input);
      updateCard(card);

    }

  });

  document.addEventListener('input', function(event) {

    if (!event.target.matches('.patriox-market [data-qty]')) {
      return;
    }

    var card = event.target.closest('[data-patriox-card]');

    if (card) {
      updateCard(card);
    }

  });

  document.addEventListener('change', function(event) {

    if (!event.target.matches('.patriox-market [data-qty]')) {
      return;
    }

    event.target.value = getQuantity(event.target);

    var card = event.target.closest('[data-patriox-card]');

    if (card) {
      updateCard(card);
    }

  });

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
